// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2CImC","legacyBtn":"MutateMid_legacyBtn__3VkRb"};